import React from 'react';
import {useLocation} from 'react-router-dom';
import useAppRouter from "../../hooks/useAppRouter";

export const NotFoundPage: React.FC = () => {
  const { gotoTopByUser } = useAppRouter();
  const { search} = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const isEnableGoto = urlSearchParams.get('goto');

  return (
    <div className="min-h-full bg-primary flex flex-col justify-center items-center p-16">
      <div className="text-8xl text-white font-bold">404</div>
      <div className="text-5xl text-white font-bold">Not Found</div>
      <div className="text-white font-semibold mt-6">お探しのページが見つかりません。削除もしくは移動された可能性があります。</div>
      { (isEnableGoto !== 'off' ) && (
        <div className="flex justify-center">
          <button
            type="button"
            className="absolute bottom-0 text-white font-semibold focus:text-topacity-50 mb-8"
            onClick={() => gotoTopByUser()}
          >
            TOPページへ戻る &gt;
          </button>
        </div>
      )}
    </div>
  );
};
